import { useState } from 'react';

export default function useConfiguracaoSimulador() {
    const [isFormDrawerVisible, setIsFormDrawerVisible] = useState(false);

    return {
        setIsFormDrawerVisible,
        isFormDrawerVisible,
    }
}
